import React from "react";
import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { CommonButton } from "../../../../common/CommonButton";
import { AppImages } from "../../../../utility/AppImages";

interface BeltExchangeSuccessModalProps {
  visible: boolean;
  onClose: () => void;
  fromBeltImage: any;
  toBeltImage: any;
  fromBeltName: string;
  toBeltName: string;
  fromAmount: number;
  toAmount: number;
}

export default function BeltExchangeSuccessModal({
  visible,
  onClose,
  fromBeltImage,
  toBeltImage,
  fromBeltName,
  toBeltName,
  fromAmount,
  toAmount,
}: BeltExchangeSuccessModalProps) {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LinearGradient
          colors={["#111827", "#000"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={{
            width: "90%",
            maxWidth: 600,
            padding: 24,
            borderRadius: 8,
            borderWidth: 1.6,
            borderColor: "rgba(34, 197, 94, 0.50)",
            alignItems: "center",
          }}
        >
          {/* Header with Close Button */}
          <View
            style={{
              width: "100%",
              borderBottomWidth: 0.5,
              borderBottomColor: "#D6D6D6",
              paddingBottom: 16,
              marginBottom: 24,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_24,
                { flex: 1 },
              ]}
            >
              Belts Exchanged Successfully
            </Text>
            <TouchableOpacity
              onPress={onClose}
              style={{
                padding: 4,
              }}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height: 24,
                  width: 24,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>

          {/* Success Icon */}
          <View
            style={{
              width: 80,
              height: 80,
              borderRadius: 40,
              backgroundColor: "rgba(34, 197, 94, 0.2)",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 24,
            }}
          >
            <View
              style={{
                width: 50,
                height: 50,
                borderRadius: 25,
                backgroundColor: "#22C55E",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text style={{ color: AppColors.white, fontSize: 32 }}>✓</Text>
            </View>
          </View>

          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_16,
              { marginBottom: 32, textAlign: "center" },
            ]}
          >
            You've successfully Exchanged
          </Text>

          {/* Conversion Visual */}
          <LinearGradient
            colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
              width: "100%",
              padding: 32,
              borderRadius: 8,
              borderWidth: 1,
              borderColor: "#374151",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
              marginBottom: 32,
            }}
          >
            {/* From Belt */}
            <View style={{ alignItems: "center", gap: 12 }}>
              <Image
                source={fromBeltImage}
                style={{
                  width: 100,
                  height: 100,
                  resizeMode: "contain",
                }}
              />
              <Text style={[AppFontStyle.BOLD_ANYBODY_18, { textAlign: "center" }]}>
                {fromAmount} {fromBeltName} Belt{fromAmount !== 1 ? "s" : ""}
              </Text>
            </View>

            {/* Arrow */}
            <View>
              <Text
                style={{
                  fontSize: 40,
                  color: AppColors.white,
                  opacity: 0.5,
                }}
              >
                →
              </Text>
            </View>

            {/* To Belt */}
            <View style={{ alignItems: "center", gap: 12 }}>
              <Image
                source={toBeltImage}
                style={{
                  width: 100,
                  height: 100,
                  resizeMode: "contain",
                }}
              />
              <Text style={[AppFontStyle.BOLD_ANYBODY_18, { textAlign: "center" }]}>
                {toAmount} {toBeltName} Belt{toAmount !== 1 ? "s" : ""}
              </Text>
            </View>
          </LinearGradient>

          {/* View Belts Button */}
          <LinearGradient
            colors={["#22C55E", "#16A34A"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={{
              borderRadius: 6,
              alignSelf: "center",
            }}
          >
            <CommonButton
              buttonStyle={{
                paddingVertical: 10,
                paddingHorizontal: 24,
                backgroundColor: "transparent",
                borderRadius: 6,
              }}
              textStyle={[AppFontStyle.SEMIBOLD_ANYBODY_16, {}]}
              title="View Belts"
              onTap={onClose}
            />
          </LinearGradient>
        </LinearGradient>
      </View>
    </Modal>
  );
}
